import React from "react";
import axios from "axios";
import ApiComponent from "./ApiComponent";
import axiosRetry from "axios-retry";

class PageApiComponent extends ApiComponent
{
    constructor() {
        super();
    }

    show(page_id, callback)
    {
        this.passport(res => {
            let backendBaseURL = process.env.REACT_APP_BACKEND_BASE_URL;
            axios.get( backendBaseURL + "api/v1/page/" + page_id, {
                headers: { Authorization: `Bearer ${res.access_token}` }
            }).then(res => {
                callback(res.data.data)
            })
        })
    }

    showBySlug(slug, callback)
    {
        let apiBaseURL = process.env.REACT_APP_API_BASE_URL;
        const url = apiBaseURL + "v1/page/" + slug;
        axios.get(url, {}).then(res => {
            callback(res.data.data)
        }).catch((reason) => {
            console.log(reason.toString())
        })
    }

    index(page_category_id, callback)
    {
        this.passport(res => {
            let backendBaseURL = process.env.REACT_APP_BACKEND_BASE_URL;
            axios.get( backendBaseURL + "api/v1/page?page_category_id=" + page_category_id, {
                headers: { Authorization: `Bearer ${res.access_token}` }
            }).then(res => {
                callback(res.data.data)
            }).catch(ex => {
                console.log(ex.message)
            })
        })
    }

    render() {
        return (
            <div />
        );
    }
}

export default PageApiComponent;
